import { useCallback, useMemo } from 'react'

import { Select, VStack } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'
import { CompanyUserRole } from 'types/graphql'

import Text, { TextSize } from 'src/components/Typography/Text'

const options: SelectOption<CompanyUserRole>[] = [
  {
    customDisplay: () => (
      <VStack>
        <Text>Employee</Text>
        <Text size={TextSize.Small} colorToken="colorTextSecondary">
          Can only access records associated with this company
        </Text>
      </VStack>
    ),
    label: 'Employee',
    value: 'Employee',
  },
  {
    customDisplay: () => (
      <VStack>
        <Text>Admin</Text>
        <Text size={TextSize.Small} colorToken="colorTextSecondary">
          Can edit company details and membership
        </Text>
      </VStack>
    ),
    label: 'Admin',
    value: 'Admin',
  },
]
type Props = {
  label?: React.ReactNode
  caption?: React.ReactNode
  onValueChange: (value: CompanyUserRole) => void
  value: CompanyUserRole
  isDisabled?: boolean
}
const UserOnCompanyRoleSelect = ({ label, caption, onValueChange, value, isDisabled }: Props) => {
  const selectedOption = useMemo(() => options.find((o) => o.value === value), [value])

  const handleSelectedOptionChange = useCallback(
    (option: SelectOption<CompanyUserRole> | undefined) => {
      if (!option) {
        return
      }
      onValueChange(option.value)
    },
    [onValueChange]
  )

  const getOptionKey = useCallback((option: SelectOption<CompanyUserRole>) => option.value, [])

  return (
    <Select
      {...(label ? { label } : { ariaLabel: 'Role' })}
      caption={caption}
      getOptionKey={getOptionKey}
      onSelectedOptionChange={handleSelectedOptionChange}
      options={options}
      selectedOption={selectedOption}
      isDisabled={isDisabled}
    />
  )
}

export default React.memo(UserOnCompanyRoleSelect)
